import React from "react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function PageTitleSkeleton() {
  return (
    <div className="page-title-skeleton-wrapper">
      <div className="breadcrumb-skeleton">
        <Skeleton height={24} containerClassName="breadcrumb-skeleton-item" />
      </div>
      <div className="page-title-skeleton">
        <Skeleton height={30} containerClassName="page-title-skeleton-item" />
      </div>
      <div className="bookmark-skeleton">
        <Skeleton height={20} containerClassName="bookmark-skeleton-item" />
      </div>

    </div>
  );
}

export default PageTitleSkeleton;
